export const REGISTER_ENTITIES = '@@state/REGISTER_ENTITIES'

const createEntitiesReducer = (entities, name) => ({
  ...entities,
  [name]: {}
})

export const registerEntities = entities => ({
  type: REGISTER_ENTITIES,
  payload: {
    entities: entities.reduce(createEntitiesReducer, {})
  },
  meta: {
    entities
  }
})
